// extracted by mini-css-extract-plugin
export default {"title":"TableToolbar_title_l0qN8"};